var FontSizeHelper = /** @class */ (function () {
    function FontSizeHelper() {
    }
    FontSizeHelper.getFontSizes = function () {
        return FontSizeHelper.fontSizes;
    };
    FontSizeHelper.defaultFontSize = '16px';
    FontSizeHelper.fontSizes = [
        { label: 12, value: '12px' },
        { label: 14, value: '14px' },
        { label: 16, value: '16px' },
        { label: 18, value: '18px' },
        { label: 20, value: '20px' },
        { label: 22, value: '22px' },
        { label: 24, value: '24px' },
        { label: 26, value: '26px' },
        { label: 28, value: '28px' },
        { label: 48, value: '48px' },
        { label: 72, value: '72px' }
    ];
    return FontSizeHelper;
}());
export { FontSizeHelper };
